import React from 'react'
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer'
import DesignButtons from './Design/DesignButtons'



const Design = () => {
  return (
    <div>
      
      <Navbar />

    






      
      
      
      <h2> Design </h2>
      <h2>All my design works goes here</h2>
      <DesignButtons />

      <Footer />

    </div>
  )
}



export default Design